export default __webpack_public_path__ + "static/media/Qrcode_wikipedia.25b5f576.jpg";